//Blocchi - structure: [name,img,[array of links]]    // if 1 link => direct link, otherwise overlay to choose between SMART (the first) and STANDARD (the second)
var base_path="https://configurator.creative-cables.com/customize";
var subfolder="assets_new_landing";
var title="What do you want to configure?";
var smart="Configure now SMART version";
var standard="Configure now STANDARD version";
let lampade_da_soffitto = [
                                 ["Single pendant",base_path+"/"+subfolder+"/img/grid/214.svg",[base_path+"/frontend.php?id_model=214"]],
                                 ["2-drop pendant",base_path+"/"+subfolder+"/img/grid/212.svg",[base_path+"/frontend.php?id_model=212"]],
                                 ["3-drop pendant",base_path+"/"+subfolder+"/img/grid/292.svg",[base_path+"/frontend.php?id_model=292"]],
                                 ["4-drop pendant",base_path+"/"+subfolder+"/img/grid/285.svg",[base_path+"/frontend.php?id_model=285"]],
                                 ["Rose-One 2-drop",base_path+"/"+subfolder+"/img/grid/213.svg",[base_path+"/frontend.php?id_model=213"]],
                                 ["Rose-One 3-drop",base_path+"/"+subfolder+"/img/grid/233.svg",[base_path+"/frontend.php?id_model=233"]],
                                 ["Rose-One 4-drop",base_path+"/"+subfolder+"/img/grid/235.svg",[base_path+"/frontend.php?id_model=235"]],                            
                                 ["Track spotlight",base_path+"/"+subfolder+"/img/grid/333.svg",[base_path+"/frontend.php?id_model=333"]],
                                 ];
let lampade_da_parete = [
                             ["Fermaluce",base_path+"/"+subfolder+"/img/grid/222.svg",[base_path+"/frontend.php?id_model=222"]],
                             ["Fermaluce with joint",base_path+"/"+subfolder+"/img/grid/223.svg",[base_path+"/frontend.php?id_model=223"]],
                             ["Fermaluce with L-extension",base_path+"/"+subfolder+"/img/grid/224.svg",[base_path+"/frontend.php?id_model=224"]],
                             ["Fermaluce with S-extension",base_path+"/"+subfolder+"/img/grid/128.svg",[base_path+"/frontend.php?id_model=128"]],
                             ["Magnetic lamp with joint",base_path+"/"+subfolder+"/img/grid/316.svg",[base_path+"/frontend.php?id_model=316"]],
                             ];

let lampade_da_tavolo = [
                            ["Posaluce",base_path+"/"+subfolder+"/img/grid/266.svg",[base_path+"/frontend.php?id_model=266"]],
                            ["Posaluce with extension",base_path+"/"+subfolder+"/img/grid/267.svg",[base_path+"/frontend.php?id_model=267"]],
                            ["Posaluce with Flex",base_path+"/"+subfolder+"/img/grid/258.svg",[base_path+"/frontend.php?id_model=258"]],
                            ["Cubetto",base_path+"/"+subfolder+"/img/grid/221.svg",[base_path+"/frontend.php?id_model=221"]],
                            ["Tache",base_path+"/"+subfolder+"/img/grid/225.svg",[base_path+"/frontend.php?id_model=225"]],
                            ["Materia",base_path+"/"+subfolder+"/img/grid/226.svg",[base_path+"/frontend.php?id_model=226"]],
                        ];

let lampade_plug_in = [
                             ["Lamp with plug",base_path+"/"+subfolder+"/img/grid/231.svg",[base_path+"/frontend.php?id_model=231"]],
                             
                        ];


let cablaggi = [
                             ["Cordset",base_path+"/"+subfolder+"/img/grid/237.svg",[base_path+"/frontend.php?id_model=238"]],
                             ];

let rosoni = [
                             ["XXL Ceiling canopies",base_path+"/"+subfolder+"/img/grid/330.svg",[base_path+"/frontend.php?id_model=329"]],
                             ];


//Menu - structure: [name,img,anchor, product list (above)]
let l=[
    ["Ceiling lamps","","lampade-da-soffitto",lampade_da_soffitto],
    ["Wall lamps","","lampade-da-parete",lampade_da_parete],
    ["Table lamps","","lampade-da-tavolo",lampade_da_tavolo],
    ["Lamps with plug","","lampade-plugin",lampade_plug_in],
    ["Cordset","","cablaggi",cablaggi],
    ["Ceiling canopies","","rosoni",rosoni],
    
];